import React, {
    useState,
    useRef,
    useContext, useEffect,
} from "react";

import { crudeDatabase } from "../data/crudeDatabase";
import { generateBlend } from "../engine/blendEngine";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";

import "../components/LoadingReceipt.css";

import { ProcessContext } from "../context/ProcessContext";






function StabilizerLaboratory({ onClose }) {

    const [currentPage, setCurrentPage] = useState(0);
    

    const formatValue = (value, decimals = 3) => {

    return Number(value ?? 0).toFixed(decimals);

};


    const report =
        JSON.parse(
            localStorage.getItem(
                "STABILIZER_REPORT"
            )
        ) || {};



    const feed =
        report.feed || {};



    const flashZone =
        report.flashZone || {};



    const tower =
        report.tower || {};



    const reboiler =
        report.reboiler || {};



    const overhead =
        report.overhead || {};



    const bottoms =
        report.bottoms || {};



    const pump =
        report.pump || {};



    const cooler =
        report.cooler || {};



    const performance =
        report.performance || {};



    const top =
        tower.top || {};



    const middle =
        tower.middle || {};



    const bottom =
        tower.bottom || {};

    const vaporComposition =
        reboiler.vaporComposition || {};

    const feedComposition =
        feed.composition || {};



    const componentFlow =
        feed.componentFlow || {};

    const flashVapor =
        flashZone.vaporComposition || {};



    const flashLiquid =
        flashZone.liquidComposition || {};

    const overheadComposition =
        overhead.composition || {};



    const bottomComposition =
        bottoms.composition || {};

    const operation = report.operation || {};




    const [position, setPosition] = useState({
        x: 120,
        y: 40
    });

    const [dragging, setDragging] = useState(false);

    const offsetRef = useRef({
        x: 0,
        y: 0
    });

    const startDrag = (e) => {

        setDragging(true);

        offsetRef.current = {

            x: e.clientX - position.x,

            y: e.clientY - position.y

        };

    };


    const handleMouseMove = (e) => {

        if (!dragging) return;

        setPosition({

            x: e.clientX - offsetRef.current.x,

            y: e.clientY - offsetRef.current.y

        });

    };


    const stopDrag = () => {

        setDragging(false);

    };



    useEffect(() => {

        window.addEventListener(
            "mousemove",
            handleMouseMove
        );

        window.addEventListener(
            "mouseup",
            stopDrag
        );

        return () => {

            window.removeEventListener(
                "mousemove",
                handleMouseMove
            );

            window.removeEventListener(
                "mouseup",
                stopDrag
            );

        };

    }, [dragging]);


console.log(
"STABILIZER REPORT DATA",
report
);


    return (

        <div
            className="receipt-window"
            style={{
                left: position.x,
                top: position.y,
                width: "680px",
                height: "88vh",
                display: "flex",
                flexDirection: "column"
            }}
        >


            {/* HEADER */}

            <div
                className="receipt-header"
                onMouseDown={startDrag}
                style={{
                    cursor: "move"
                }}
            >

                <div>
                    NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION
                </div>


                <button
                    className="receipt-close"
                    onClick={onClose}
                >
                    ✕
                </button>


            </div>





            <div className="receipt-scroll">

                {currentPage === 0 && (

                    /* ==========================================
   PAGE 0
   COVER PAGE
========================================== */

                    <div className="receipt-page">

                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: 30
                            }}
                        >

                            <div
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "#003366",
                                    letterSpacing: 1
                                }}
                            >
                                NK TECH NIGERIA LIMITED
                            </div>

                            <div
                                style={{
                                    fontSize: 14,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                NK REFINERY DIGITAL TWIN SYSTEM
                            </div>

                            <div
                                style={{
                                    fontSize: 13,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                PROCESS SIMULATION • DIGITAL LABORATORY • OPERATIONS MONITORING
                            </div>

                        </div>

                        <hr />

                        <div
                            style={{
                                textAlign: "center",
                                margin: "30px 0"
                            }}
                        >

                            <h1
                                style={{
                                    margin: 0,
                                    fontSize: 34,
                                    color: "#0B4F9C",
                                    letterSpacing: 2
                                }}
                            >
                                STABILIZER TOWER
                            </h1>

                            <h2
                                style={{
                                    marginTop: 10,
                                    marginBottom: 8,
                                    color: "#444",
                                    fontWeight: 600
                                }}
                            >
                                PROCESS LABORATORY REPORT
                            </h2>

                            <div
                                style={{
                                    fontSize: 17,
                                    fontWeight: "bold",
                                    color: "#666"
                                }}
                            >
                                STABILIZER UNIT
                            </div>

                            <div
                                style={{
                                    marginTop: 10,
                                    fontSize: 13,
                                    color: "#888"
                                }}
                            >
                                Equipment Tag : T-301
                            </div>

                        </div>


                        <table
                            className="receipt-table"
                            style={{
                                marginTop: "50px"
                            }}
                        >

                            <tbody>

                                <tr>

                                    <td>

                                        Report Type

                                    </td>

                                    <td>

                                        Stabilizer Tower Performance Report

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Plant

                                    </td>

                                    <td>

                                        NK Refinery Digital Twin

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Unit

                                    </td>

                                    <td>

                                        Stabilizer Tower

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Feed Flow

                                    </td>

                                    <td>

                                        {feed.flow?.toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Feed Temperature

                                    </td>

                                    <td>

                                        {feed.temperature?.toFixed(2)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Feed Pressure

                                    </td>

                                    <td>

                                        {feed.pressure?.toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Separation Efficiency

                                    </td>

                                    <td>

                                        {(tower.separationEfficiency * 100).toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Report Generated

                                    </td>

                                    <td>

                                        {report.reportInfo?.generatedOn}

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <div
                            style={{
                                marginTop: "50px",
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center"
                            }}
                        >

                            <div>

                            <QRCode

                                value={JSON.stringify({

                                    System:
                                    "NK REFINERY DIGITAL TWIN SYSTEM",

                                    Report:
                                    "STABILIZER TOWER PERFORMANCE REPORT",

                                    Unit:
                                    "STABILIZATION TOWER",

                                    ReportID:
                                    report.receiptNumber || "STAB-REPORT",

                                    Date:
                                    new Date().toISOString()

                                })}

                                size={120}

                            />

                            </div>


                            <div>

                                <Barcode

                                    value={`STAB-${Date.now()}`}

                                    width={1.5}

                                    height={60}

                                    fontSize={14}

                                />

                            </div>

                        </div>


                        <div
                            style={{
                                marginTop: "40px",
                                textAlign: "center",
                                fontStyle: "italic",
                                color: "#555"
                            }}
                        >

                            This report was generated automatically from live process
                            simulation data within the NK Refinery Digital Twin System.
                            The values presented represent simulated operating conditions
                            intended for training, process monitoring, educational,
                            demonstration and performance evaluation purposes.

                        </div>

                    </div>

                )}


                {currentPage === 1 && (

                    /* ==========================================
   PAGE 1
   FEED ANALYSIS
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            1. STABILIZER FEED ANALYSIS

                        </h2>


                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Feed Flow</td>

                                    <td>{feed.flow?.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Feed Temperature</td>

                                    <td>{feed.temperature?.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Feed Pressure</td>

                                    <td>{feed.pressure?.toFixed(3)} barg</td>

                                </tr>

                                <tr>

                                    <td>Total Feed</td>

                                    <td>{feed.totalFeed?.toFixed(3)} m³/hr</td>

                                </tr>

                            </tbody>

                        </table>



                        <br />



                        <h3>

                            Feed Composition

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Composition</th>

                                    <th>Component Flow (m³/hr)</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Methane</td>

                                    <td>{(feedComposition.Methane * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.Methane?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>Ethane</td>

                                    <td>{(feedComposition.Ethane * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.Ethane?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>Propane</td>

                                    <td>{(feedComposition.Propane * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.Propane?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>i-Butane</td>

                                    <td>{(feedComposition.iButane * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.iButane?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>n-Butane</td>

                                    <td>{(feedComposition.nButane * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.nButane?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>H₂S</td>

                                    <td>{(feedComposition.H2S * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.H2S?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>CO₂</td>

                                    <td>{(feedComposition.CO2 * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.CO2?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>Hydrogen</td>

                                    <td>{(feedComposition.Hydrogen * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.Hydrogen?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>Pentanes+</td>

                                    <td>{(feedComposition.PentanesPlus * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.PentanesPlus?.toFixed(4)}</td>

                                </tr>

                                <tr>

                                    <td>Water</td>

                                    <td>{(feedComposition.Water * 100).toFixed(3)} %</td>

                                    <td>{componentFlow.Water?.toFixed(4)}</td>

                                </tr>

                            </tbody>

                        </table>



                        <br />



                        <h3>

                            Feed Summary

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Light Hydrocarbons (C₁–C₄)</td>

                                    <td>

                                        {(
                                            (
                                                feedComposition.Methane +
                                                feedComposition.Ethane +
                                                feedComposition.Propane +
                                                feedComposition.iButane +
                                                feedComposition.nButane
                                            ) * 100
                                        ).toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>Pentanes Plus</td>

                                    <td>

                                        {(feedComposition.PentanesPlus * 100).toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>Acid Gas (H₂S + CO₂)</td>

                                    <td>

                                        {(
                                            (
                                                feedComposition.H2S +
                                                feedComposition.CO2
                                            ) * 100
                                        ).toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>Water Content</td>

                                    <td>

                                        {(feedComposition.Water * 100).toFixed(2)} %

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}


                {currentPage === 2 && (

                    /* ==========================================
   PAGE 2
   FLASH ZONE ANALYSIS
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            2. FLASH ZONE ANALYSIS

                        </h2>


                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Temperature Factor</td>

                                    <td>{flashZone.temperatureFactor?.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Pressure Factor</td>

                                    <td>{flashZone.pressureFactor?.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Flash Severity</td>

                                    <td>{flashZone.flashSeverity?.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Total Vapor Flow</td>

                                    <td>{flashZone.vaporFlow?.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Total Liquid Flow</td>

                                    <td>{flashZone.liquidFlow?.toFixed(3)} m³/hr</td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Flash Vapor Composition

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Flow (m³/hr)</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr><td>Methane</td><td>{flashVapor.Methane?.toFixed(4)}</td></tr>

                                <tr><td>Ethane</td><td>{flashVapor.Ethane?.toFixed(4)}</td></tr>

                                <tr><td>Propane</td><td>{flashVapor.Propane?.toFixed(4)}</td></tr>

                                <tr><td>i-Butane</td><td>{flashVapor.iButane?.toFixed(4)}</td></tr>

                                <tr><td>n-Butane</td><td>{flashVapor.nButane?.toFixed(4)}</td></tr>

                                <tr><td>H₂S</td><td>{flashVapor.H2S?.toFixed(4)}</td></tr>

                                <tr><td>CO₂</td><td>{flashVapor.CO2?.toFixed(4)}</td></tr>

                                <tr><td>Hydrogen</td><td>{flashVapor.Hydrogen?.toFixed(4)}</td></tr>

                                <tr><td>Pentanes+</td><td>{flashVapor.PentanesPlus?.toFixed(4)}</td></tr>

                                <tr><td>Water</td><td>{flashVapor.Water?.toFixed(4)}</td></tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Flash Liquid Composition

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Flow (m³/hr)</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr><td>Methane</td><td>{flashLiquid.Methane?.toFixed(4)}</td></tr>

                                <tr><td>Ethane</td><td>{flashLiquid.Ethane?.toFixed(4)}</td></tr>

                                <tr><td>Propane</td><td>{flashLiquid.Propane?.toFixed(4)}</td></tr>

                                <tr><td>i-Butane</td><td>{flashLiquid.iButane?.toFixed(4)}</td></tr>

                                <tr><td>n-Butane</td><td>{flashLiquid.nButane?.toFixed(4)}</td></tr>

                                <tr><td>H₂S</td><td>{flashLiquid.H2S?.toFixed(4)}</td></tr>

                                <tr><td>CO₂</td><td>{flashLiquid.CO2?.toFixed(4)}</td></tr>

                                <tr><td>Hydrogen</td><td>{flashLiquid.Hydrogen?.toFixed(4)}</td></tr>

                                <tr><td>Pentanes+</td><td>{flashLiquid.PentanesPlus?.toFixed(4)}</td></tr>

                                <tr><td>Water</td><td>{flashLiquid.Water?.toFixed(4)}</td></tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Flash Zone Interpretation

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Feed Vaporized</td>

                                    <td>

                                        {(
                                            (flashZone.vaporFlow /
                                                feed.totalFeed) * 100
                                        ).toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>Feed Remaining as Liquid</td>

                                    <td>

                                        {(
                                            (flashZone.liquidFlow /
                                                feed.totalFeed) * 100
                                        ).toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>Flash Zone Status</td>

                                    <td>

                                        {

                                            flashZone.flashSeverity > 0.80

                                                ? "Excellent Flash Separation"

                                                :

                                                flashZone.flashSeverity > 0.60

                                                    ? "Good Flash Separation"

                                                    :

                                                    flashZone.flashSeverity > 0.40

                                                        ? "Moderate Flash Separation"

                                                        :

                                                        "Poor Flash Separation"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}




                {currentPage === 3 && (

                    /* ==========================================
   PAGE 3
   STABILIZER TOWER PERFORMANCE
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            3. STABILIZER TOWER PERFORMANCE

                        </h2>


                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Location</th>

                                    <th>Temperature (°C)</th>

                                    <th>Pressure (barg)</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Top Section</td>

                                    <td>{top.temperature?.toFixed(2)}</td>

                                    <td>{top.pressure?.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Middle Section</td>

                                    <td>{middle.temperature?.toFixed(2)}</td>

                                    <td>{middle.pressure?.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Bottom Section</td>

                                    <td>{bottom.temperature?.toFixed(2)}</td>

                                    <td>{bottom.pressure?.toFixed(3)}</td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Tower Hydraulic Performance

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Internal Vapor Flow</td>

                                    <td>

                                        {tower.internalVapor?.toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Reflux Ratio</td>

                                    <td>

                                        {tower.refluxRatio?.toFixed(3)}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Reflux Cooling Factor</td>

                                    <td>

                                        {tower.refluxCooling?.toFixed(3)}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Separation Efficiency</td>

                                    <td>

                                        {(tower.separationEfficiency * 100).toFixed(2)} %

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Temperature Profile

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>

                                        Top Temperature

                                    </td>

                                    <td>

                                        {top.temperature?.toFixed(2)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Middle Temperature

                                    </td>

                                    <td>

                                        {middle.temperature?.toFixed(2)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Bottom Temperature

                                    </td>

                                    <td>

                                        {bottom.temperature?.toFixed(2)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Temperature Gradient

                                    </td>

                                    <td>

                                        {(bottom.temperature - top.temperature).toFixed(2)} °C

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Pressure Profile

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>

                                        Top Pressure

                                    </td>

                                    <td>

                                        {top.pressure?.toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Middle Pressure

                                    </td>

                                    <td>

                                        {middle.pressure?.toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Bottom Pressure

                                    </td>

                                    <td>

                                        {bottom.pressure?.toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Tower Pressure Drop

                                    </td>

                                    <td>

                                        {(bottom.pressure - top.pressure).toFixed(3)} barg

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Tower Performance Assessment

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>

                                        Internal Vapor Loading

                                    </td>

                                    <td>

                                        {

                                            tower.internalVapor > 5

                                                ?

                                                "High"

                                                :

                                                tower.internalVapor > 2

                                                    ?

                                                    "Normal"

                                                    :

                                                    "Low"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Reflux Performance

                                    </td>

                                    <td>

                                        {

                                            tower.refluxCooling > 0.15

                                                ?

                                                "Excellent"

                                                :

                                                tower.refluxCooling > 0.08

                                                    ?

                                                    "Good"

                                                    :

                                                    "Poor"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Separation Performance

                                    </td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.90

                                                ?

                                                "Excellent"

                                                :

                                                tower.separationEfficiency > 0.80

                                                    ?

                                                    "Very Good"

                                                    :

                                                    tower.separationEfficiency > 0.70

                                                        ?

                                                        "Good"

                                                        :

                                                        tower.separationEfficiency > 0.60

                                                            ?

                                                            "Fair"

                                                            :

                                                            "Poor"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}


 
                {currentPage === 4 && (

                    /* ==========================================
   PAGE 4
   KETTLE REBOILER PERFORMANCE
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            4. KETTLE REBOILER PERFORMANCE

                        </h2>


                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Circulation Flow</td>

                                    <td>

                                        {reboiler.circulationFlow?.toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Reboiler Duty</td>

                                    <td>

                                        {reboiler.duty?.toFixed(3)}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Heat Transfer</td>

                                    <td>

                                        {reboiler.heatTransfer?.toFixed(3)}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stripping Factor</td>

                                    <td>

                                        {reboiler.strippingFactor?.toFixed(3)}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Generated Vapor Flow</td>

                                    <td>

                                        {reboiler.vaporFlow?.toFixed(3)} m³/hr

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Reboiler Process Conditions

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Parameter</th>

                                    <th>Inlet</th>

                                    <th>Outlet</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Temperature (°C)</td>

                                    <td>

                                        {reboiler.inletTemperature?.toFixed(2)}

                                    </td>

                                    <td>

                                        {reboiler.outletTemperature?.toFixed(2)}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Pressure (barg)</td>

                                    <td>

                                        {reboiler.inletPressure?.toFixed(3)}

                                    </td>

                                    <td>

                                        {reboiler.outletPressure?.toFixed(3)}

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Hot Oil Heating Medium

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Hot Oil Flow</td>

                                    <td>

                                        {reboiler.hotOilFlow?.toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Hot Oil Inlet Temperature</td>

                                    <td>

                                        {reboiler.hotOilInletTemperature?.toFixed(2)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Hot Oil Outlet Temperature</td>

                                    <td>

                                        {reboiler.hotOilOutletTemperature?.toFixed(2)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Hot Oil Inlet Pressure</td>

                                    <td>

                                        {reboiler.hotOilPressure?.toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>Hot Oil Outlet Pressure</td>

                                    <td>

                                        {reboiler.hotOilOutletPressure?.toFixed(3)} barg

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Generated Stripping Vapor

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Flow (m³/hr)</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr><td>Methane</td><td>{vaporComposition.Methane?.toFixed(4)}</td></tr>

                                <tr><td>Ethane</td><td>{vaporComposition.Ethane?.toFixed(4)}</td></tr>

                                <tr><td>Propane</td><td>{vaporComposition.Propane?.toFixed(4)}</td></tr>

                                <tr><td>i-Butane</td><td>{vaporComposition.iButane?.toFixed(4)}</td></tr>

                                <tr><td>n-Butane</td><td>{vaporComposition.nButane?.toFixed(4)}</td></tr>

                                <tr><td>H₂S</td><td>{vaporComposition.H2S?.toFixed(4)}</td></tr>

                                <tr><td>CO₂</td><td>{vaporComposition.CO2?.toFixed(4)}</td></tr>

                                <tr><td>Hydrogen</td><td>{vaporComposition.Hydrogen?.toFixed(4)}</td></tr>

                                <tr><td>Pentanes+</td><td>{vaporComposition.PentanesPlus?.toFixed(4)}</td></tr>

                                <tr><td>Water</td><td>{vaporComposition.Water?.toFixed(4)}</td></tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Reboiler Performance Assessment

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Heat Transfer Status</td>

                                    <td>

                                        {

                                            reboiler.heatTransfer > 40

                                                ?

                                                "Excellent"

                                                :

                                                reboiler.heatTransfer > 20

                                                    ?

                                                    "Good"

                                                    :

                                                    reboiler.heatTransfer > 10

                                                        ?

                                                        "Moderate"

                                                        :

                                                        "Low"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stripping Performance</td>

                                    <td>

                                        {

                                            reboiler.strippingFactor > 0.90

                                                ?

                                                "Excellent"

                                                :

                                                reboiler.strippingFactor > 0.75

                                                    ?

                                                    "Very Good"

                                                    :

                                                    reboiler.strippingFactor > 0.50

                                                        ?

                                                        "Good"

                                                        :

                                                        "Poor"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Reboiler Condition</td>

                                    <td>

                                        {

                                            reboiler.duty > 15

                                                ?

                                                "Normal Operation"

                                                :

                                                "Low Heat Input"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}


   
                {currentPage === 5 && (

                    /* ==========================================
   PAGE 5
   OVERHEAD LPG PRODUCT ANALYSIS
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            5. OVERHEAD LPG PRODUCT ANALYSIS

                        </h2>


                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Product</td>

                                    <td>Overhead LPG</td>

                                </tr>

                                <tr>

                                    <td>Total Product Flow</td>

                                    <td>{overhead.flow?.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Product Temperature</td>

                                    <td>{overhead.temperature?.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Product Pressure</td>

                                    <td>{overhead.pressure?.toFixed(3)} barg</td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            LPG Composition

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Flow (m³/hr)</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr><td>Methane</td><td>{overheadComposition.Methane?.toFixed(4)}</td></tr>

                                <tr><td>Ethane</td><td>{overheadComposition.Ethane?.toFixed(4)}</td></tr>

                                <tr><td>Propane</td><td>{overheadComposition.Propane?.toFixed(4)}</td></tr>

                                <tr><td>i-Butane</td><td>{overheadComposition.iButane?.toFixed(4)}</td></tr>

                                <tr><td>n-Butane</td><td>{overheadComposition.nButane?.toFixed(4)}</td></tr>

                                <tr><td>H₂S</td><td>{overheadComposition.H2S?.toFixed(4)}</td></tr>

                                <tr><td>CO₂</td><td>{overheadComposition.CO2?.toFixed(4)}</td></tr>

                                <tr><td>Hydrogen</td><td>{overheadComposition.Hydrogen?.toFixed(4)}</td></tr>

                                <tr><td>Pentanes+</td><td>{overheadComposition.PentanesPlus?.toFixed(4)}</td></tr>

                                <tr><td>Water</td><td>{overheadComposition.Water?.toFixed(4)}</td></tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            LPG Quality Indicators

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Total C₃ + C₄ Recovery</td>

                                    <td>

                                        {(
                                            overheadComposition.Propane +
                                            overheadComposition.iButane +
                                            overheadComposition.nButane
                                        ).toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Light Ends (C₁ + C₂)</td>

                                    <td>

                                        {(
                                            overheadComposition.Methane +
                                            overheadComposition.Ethane
                                        ).toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Acid Gas Content</td>

                                    <td>

                                        {(
                                            overheadComposition.H2S +
                                            overheadComposition.CO2
                                        ).toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Pentanes Carryover</td>

                                    <td>

                                        {overheadComposition.PentanesPlus?.toFixed(4)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Water Carryover</td>

                                    <td>

                                        {overheadComposition.Water?.toFixed(4)} m³/hr

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Product Quality Assessment

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>LPG Recovery</td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.90

                                                ? "Excellent"

                                                : tower.separationEfficiency > 0.80

                                                    ? "Very Good"

                                                    : tower.separationEfficiency > 0.70

                                                        ? "Good"

                                                        : "Fair"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Pentanes Contamination</td>

                                    <td>

                                        {

                                            overheadComposition.PentanesPlus < 0.05

                                                ? "Very Low"

                                                : overheadComposition.PentanesPlus < 0.10

                                                    ? "Low"

                                                    : "High"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall LPG Product Quality</td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.90

                                                ? "Pipeline Quality"

                                                : tower.separationEfficiency > 0.80

                                                    ? "Commercial Grade"

                                                    : "Off Specification"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}


                {currentPage === 6 && (

                    /* ==========================================
   PAGE 6
   STABILIZED NAPHTHA PRODUCT ANALYSIS
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            6. STABILIZED NAPHTHA PRODUCT ANALYSIS

                        </h2>


                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Product</td>

                                    <td>Stabilized Naphtha</td>

                                </tr>

                                <tr>

                                    <td>Total Product Flow</td>

                                    <td>{bottoms.flow?.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Product Temperature</td>

                                    <td>{bottoms.temperature?.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Product Pressure</td>

                                    <td>{bottoms.pressure?.toFixed(3)} barg</td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Product Composition

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Flow (m³/hr)</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr><td>Methane</td><td>{bottomComposition.Methane?.toFixed(4)}</td></tr>

                                <tr><td>Ethane</td><td>{bottomComposition.Ethane?.toFixed(4)}</td></tr>

                                <tr><td>Propane</td><td>{bottomComposition.Propane?.toFixed(4)}</td></tr>

                                <tr><td>i-Butane</td><td>{bottomComposition.iButane?.toFixed(4)}</td></tr>

                                <tr><td>n-Butane</td><td>{bottomComposition.nButane?.toFixed(4)}</td></tr>

                                <tr><td>H₂S</td><td>{bottomComposition.H2S?.toFixed(4)}</td></tr>

                                <tr><td>CO₂</td><td>{bottomComposition.CO2?.toFixed(4)}</td></tr>

                                <tr><td>Hydrogen</td><td>{bottomComposition.Hydrogen?.toFixed(4)}</td></tr>

                                <tr><td>Pentanes+</td><td>{bottomComposition.PentanesPlus?.toFixed(4)}</td></tr>

                                <tr><td>Water</td><td>{bottomComposition.Water?.toFixed(4)}</td></tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Product Quality Indicators

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Residual Light Ends (C₁ + C₂)</td>

                                    <td>

                                        {(
                                            bottomComposition.Methane +
                                            bottomComposition.Ethane
                                        ).toFixed(4)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Residual LPG (C₃ + C₄)</td>

                                    <td>

                                        {(
                                            bottomComposition.Propane +
                                            bottomComposition.iButane +
                                            bottomComposition.nButane
                                        ).toFixed(4)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Pentanes+ Content</td>

                                    <td>

                                        {bottomComposition.PentanesPlus?.toFixed(4)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Water Content</td>

                                    <td>

                                        {bottomComposition.Water?.toFixed(4)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Acid Gas Content</td>

                                    <td>

                                        {(
                                            bottomComposition.H2S +
                                            bottomComposition.CO2
                                        ).toFixed(4)} m³/hr

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Stabilized Naphtha Assessment

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Light Ends Removal</td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.90

                                                ? "Excellent"

                                                : tower.separationEfficiency > 0.80

                                                    ? "Very Good"

                                                    : tower.separationEfficiency > 0.70

                                                        ? "Good"

                                                        : "Poor"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Naphtha Stability</td>

                                    <td>

                                        {

                                            (
                                                bottomComposition.Propane +
                                                bottomComposition.iButane +
                                                bottomComposition.nButane
                                            ) < 0.20

                                                ? "Excellent"

                                                : (
                                                    bottomComposition.Propane +
                                                    bottomComposition.iButane +
                                                    bottomComposition.nButane
                                                ) < 0.50

                                                    ? "Good"

                                                    : "Needs Further Stabilization"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Product Quality</td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.90

                                                ? "Premium Stabilized Naphtha"

                                                : tower.separationEfficiency > 0.80

                                                    ? "Commercial Grade"

                                                    : "Off Specification"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Product Summary

                        </h3>

                        <p>

                            The stabilized naphtha leaving the tower represents the heavy liquid
                            product after removal of the majority of dissolved LPG components.
                            Product quality is directly influenced by reflux performance, reboiler
                            duty and stripping efficiency. Low residual C₃/C₄ components indicate
                            effective stabilization and improved storage safety.

                        </p>

                    </div>

                )}



                {currentPage === 7 && (

                    /* ==========================================
   PAGE 7
   OVERALL PERFORMANCE ASSESSMENT
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            7. OVERALL STABILIZER PERFORMANCE ASSESSMENT

                        </h2>


                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Performance Indicator</th>

                                    <th>Status</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Feed Stability</td>

                                    <td>

                                        {

                                            feed.flow > 0

                                                ? "Normal"

                                                : "No Feed"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Flash Separation</td>

                                    <td>

                                        {

                                            flashZone.flashSeverity > 0.80

                                                ? "Excellent"

                                                : flashZone.flashSeverity > 0.60

                                                    ? "Very Good"

                                                    : flashZone.flashSeverity > 0.40

                                                        ? "Moderate"

                                                        : "Poor"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Tower Separation</td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.90

                                                ? "Excellent"

                                                : tower.separationEfficiency > 0.80

                                                    ? "Good"

                                                    : tower.separationEfficiency > 0.70

                                                        ? "Fair"

                                                        : "Poor"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Reboiler Operation</td>

                                    <td>

                                        {

                                            reboiler.strippingFactor > 0.80

                                                ? "Excellent"

                                                : reboiler.strippingFactor > 0.60

                                                    ? "Good"

                                                    : "Low Duty"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>LPG Recovery</td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.90

                                                ? "High"

                                                : tower.separationEfficiency > 0.75

                                                    ? "Normal"

                                                    : "Low"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stabilized Naphtha Quality</td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.90

                                                ? "Premium"

                                                : tower.separationEfficiency > 0.80

                                                    ? "Commercial"

                                                    : "Off Specification"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Overall Equipment Performance

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Flash Drum</td>

                                    <td>Operating Normally</td>

                                </tr>

                                <tr>

                                    <td>Stabilizer Tower</td>

                                    <td>

                                        {

                                            tower.separationEfficiency > 0.85

                                                ? "Stable"

                                                : "Requires Monitoring"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Kettle Reboiler</td>

                                    <td>

                                        {

                                            reboiler.duty > 15

                                                ? "Heat Transfer Normal"

                                                : "Low Heat Input"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Reflux System</td>

                                    <td>

                                        {

                                            operation.refluxRatio > 0.20

                                                ? "Adequate"

                                                : "Low Reflux"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Cooling System</td>

                                    <td>

                                        {

                                            operation.refluxCooling > 0

                                                ? "Operational"

                                                : "Inactive"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Operational Recommendations

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>

                                        {

                                            tower.separationEfficiency < 0.80

                                                ?

                                                "Increase reboiler duty to improve stripping efficiency."

                                                :

                                                "Reboiler duty is within recommended operating range."

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        {

                                            operation.refluxRatio < 0.15

                                                ?

                                                "Increase reflux flow for better LPG recovery."

                                                :

                                                "Reflux ratio is satisfactory."

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        {

                                            overheadComposition.PentanesPlus > 0.10

                                                ?

                                                "Reduce pentanes carryover into LPG product."

                                                :

                                                "LPG product contamination is minimal."

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        {

                                            reboiler.strippingFactor < 0.60

                                                ?

                                                "Inspect reboiler heating medium and circulation."

                                                :

                                                "Reboiler performance is acceptable."

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>

                                        Continue routine monitoring of tower temperatures,
                                        pressures, reflux flow and bottom product quality.

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Final Operational Remarks

                        </h3>

                        <p>

                            The stabilizer tower has been evaluated using live process data
                            generated by the NK Refinery Digital Twin System. The report
                            confirms the operational condition of the flash section, stripping
                            section, kettle reboiler, reflux system, overhead LPG recovery and
                            stabilized naphtha production. Recommendations above should be
                            considered to optimize separation efficiency, maximize LPG recovery
                            and improve stabilized naphtha quality.

                        </p>

                    </div>

                )}



                {currentPage === 8 && (

                    /* ==========================================
   PAGE 8
   APPROVAL & CERTIFICATION
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            8. REPORT AUTHENTICATION & CERTIFICATION

                        </h2>


                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Report Number</td>

                                    <td>{report.receiptNumber}</td>

                                </tr>

                                <tr>

                                    <td>Product Batch Number</td>

                                    <td>{report.batchNumber}</td>

                                </tr>

                                <tr>

                                    <td>Permit Number</td>

                                    <td>{report.permitNumber}</td>

                                </tr>

                                <tr>

                                    <td>Report Date</td>

                                    <td>{report.date}</td>

                                </tr>

                                <tr>

                                    <td>Report Time</td>

                                    <td>{report.time}</td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                marginTop: "30px",
                                marginBottom: "30px"
                            }}
                        >

                            <div
                                style={{
                                    textAlign: "center"
                                }}
                            >

                                <QRCode
                                    value={report.receiptNumber || "NK-STABILIZER"}
                                    size={130}
                                />

                                <p>

                                    QR Verification

                                </p>

                            </div>


                            <div
                                style={{
                                    textAlign: "center"
                                }}
                            >

                                <Barcode
                                    value={report.receiptNumber || "NK-STABILIZER"}
                                    width={1.5}
                                    height={70}
                                    fontSize={14}
                                />

                                <p>

                                    Report Barcode

                                </p>

                            </div>

                        </div>


                        <br />


                        <h3>

                            Laboratory Certification

                        </h3>

                        <p>

                            This report has been automatically generated by the
                            <strong> NK Refinery Digital Twin System </strong>
                            using simulated refinery operating data.
                            The calculations presented herein are based on
                            real-time process variables, equipment operating
                            conditions, process thermodynamics, mass balance,
                            heat balance and refinery engineering calculations.

                        </p>


                        <br />


                        <h3>

                            Disclaimer

                        </h3>

                        <p>

                            This report is intended solely for refinery operator
                            training, process simulation, engineering studies,
                            digital twin demonstration and educational purposes.
                            The values contained herein are simulation-generated
                            and should not be used for commercial custody transfer,
                            fiscal measurement or regulatory reporting without
                            independent laboratory verification.

                        </p>


                        <br />


                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Prepared By</th>

                                    <th>Reviewed By</th>

                                    <th>Approved By</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td style={{ height: "90px" }}>

                                        ______________________

                                        <br /><br />

                                        Digital Twin Laboratory

                                    </td>

                                    <td>

                                        ______________________

                                        <br /><br />

                                        Process Engineer

                                    </td>

                                    <td>

                                        ______________________

                                        <br /><br />

                                        Operations Supervisor

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <div
                            style={{
                                textAlign: "center",
                                marginTop: "40px",
                                fontWeight: "bold",
                                fontSize: "18px"
                            }}
                        >

                            ***** END OF REPORT *****

                            <br /><br />

                            NK REFINERY DIGITAL TWIN SYSTEM

                        </div>

                    </div>

                )}



                {currentPage === 9 && (

                    /* ==========================================
   PAGE 9
   PROCESS VARIABLE SUMMARY
========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            9. PROCESS VARIABLE SUMMARY

                        </h2>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Parameter</th>
                                    <th>Value</th>
                                    <th>Unit</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>
                                    <td>Feed Flow</td>
                                    <td>{feed.flow?.toFixed(3)}</td>
                                    <td>m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Feed Temperature</td>
                                    <td>{feed.temperature?.toFixed(2)}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>Feed Pressure</td>
                                    <td>{feed.pressure?.toFixed(3)}</td>
                                    <td>barg</td>
                                </tr>

                                <tr>
                                    <td>Flash Severity</td>
                                    <td>{flashZone.flashSeverity?.toFixed(3)}</td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td>Flash Vapor Flow</td>
                                    <td>{flashZone.vaporFlow?.toFixed(3)}</td>
                                    <td>m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Flash Liquid Flow</td>
                                    <td>{flashZone.liquidFlow?.toFixed(3)}</td>
                                    <td>m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Tower Vapor Flow</td>
                                    <td>{tower.internalVaporFlow?.toFixed(3)}</td>
                                    <td>m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Reflux Ratio</td>
                                    <td>{operation.refluxRatio?.toFixed(3)}</td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td>Reflux Cooling</td>
                                    <td>{operation.refluxCooling?.toFixed(3)}</td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td>Separation Efficiency</td>
                                    <td>{(tower.separationEfficiency * 100)?.toFixed(2)}</td>
                                    <td>%</td>
                                </tr>

                                <tr>
                                    <td>Reboiler Duty</td>
                                    <td>{reboiler.duty?.toFixed(3)}</td>
                                    <td>kW</td>
                                </tr>

                                <tr>
                                    <td>Stripping Factor</td>
                                    <td>{reboiler.strippingFactor?.toFixed(3)}</td>
                                    <td>-</td>
                                </tr>

                                <tr>
                                    <td>Overhead LPG Flow</td>
                                    <td>{overhead.flow?.toFixed(3)}</td>
                                    <td>m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Stabilized Naphtha Flow</td>
                                    <td>{bottoms.flow?.toFixed(3)}</td>
                                    <td>m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Corrosion Inhibitor Flow</td>
                                    <td>{operation.corrosionInhibitorFlow?.toFixed(3)}</td>
                                    <td>m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Cooling Water Temperature</td>
                                    <td>{operation.coolingWaterTemperature?.toFixed(2)}</td>
                                    <td>°C</td>
                                </tr>

                                <tr>
                                    <td>Pump Around Flow</td>
                                    <td>{reboiler.hotOilFlow?.toFixed(3)}</td>
                                    <td>m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Hot Oil Temperature</td>
                                    <td>{reboiler.hotOilTemperature?.toFixed(2)}</td>
                                    <td>°C</td>
                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Operational Summary

                        </h3>

                        <p>

                            This page summarizes the principal operating variables used by the
                            NK Refinery Digital Twin System to evaluate stabilizer tower
                            performance. The values presented represent the operating condition
                            at the instant the report was generated and provide a concise
                            reference for engineers, operators and process supervisors during
                            plant monitoring, troubleshooting and performance evaluation.

                        </p>

                    </div>

                )}



                <hr />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 25
                    }}
                >

                    <button
                        className="receipt-button"
                        disabled={currentPage === 0}
                        onClick={() => setCurrentPage(p => p - 1)}
                    >
                        ◀ Previous
                    </button>

                    <strong>
                        Page {currentPage + 1} of 10
                    </strong>

                    <button
                        className="receipt-button"
                        disabled={currentPage === 9}
                        onClick={() => setCurrentPage(p => p + 1)}
                    >
                        Next ▶
                    </button>

                </div>

                <br />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 20
                    }}
                >

                    <button
                        className="receipt-button"
                        onClick={() => window.print()}
                    >
                        Print
                    </button>

                    <button
                        className="receipt-button"
                    >
                        Export PDF
                    </button>

                    <button
                        className="receipt-button"
                        onClick={onClose}
                    >
                        Close
                    </button>

                </div>

            </div>

        </div>


    )

};

export default StabilizerLaboratory;